var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"content"},_vm._l((_vm.footerArr),function(item,index){return _c('span',{key:index,on:{"click":function($event){return _vm.operate(item.type)}}},[_vm._v(_vm._s(item.name))])}),0),_c('div',{staticClass:"copy-right"},[_vm._v("Copyright @2023 掘金之路(海南)科技有限公司 Al Right Reserved.琼ICP备2023008525号")])])
}
var staticRenderFns = []

export { render, staticRenderFns }